import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import { DialogActions } from './DialogActions';
import { tokens } from '../../theme/generated/tokens';
import { SxProps } from '../../types';

/**
 * @deprecated Old dialog system — use the `endActions` / `startActions` props on `DialogV2`
 * from `@cast/design-system`, or `DialogFooterV2` for building-block dialogs.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export type DialogFooterProps = {
  start?: ReactNode;
  end?: ReactNode;
  sx?: SxProps;
};

/**
 * @deprecated Old dialog system — use the `endActions` / `startActions` props on `DialogV2`
 * from `@cast/design-system`, or `DialogFooterV2` for building-block dialogs.
 * Old `start` / `end` map to new `startActions` / `endActions`. Wrap multiple buttons in `<ActionsGroup>`.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const DialogFooter = ({ start, end, sx }: DialogFooterProps) => {
  const hasStart = !!start;
  const hasEnd = !!end;

  return (
    <DialogActions
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderTop: tokens.theme.border.structural.neutral,
        justifyContent:
          hasStart && hasEnd
            ? 'space-between'
            : (hasStart && 'flex-start') || (hasEnd && 'flex-end') || undefined,
        ...sx,
      }}
    >
      {!!start && (
        <Stack direction="row" gap={16}>
          {start}
        </Stack>
      )}
      {!!end && (
        <Stack direction="row" gap={16}>
          {end}
        </Stack>
      )}
    </DialogActions>
  );
};
